<template>
  <v-card>
    <v-card-title>
      Organizations
      <v-spacer></v-spacer>
      <v-text-field
        class="pr-4"
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>

      <v-btn @click="createOrganization" color="primary">Create Organization</v-btn>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="organizations"
      item-key="name"
      :search="search"
    >
      <template v-slot:[`item.status`]="{ item }">
        <label v-if="item.status === 'A'">Active</label>
        <label v-if="item.status === 'I'">Inactive</label>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="$router.push({ path: `organization/${item._id}/edit` })">edit</v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import RestResource from "@/services/dataServiceAdmin.js";
const service = new RestResource();

export default {
  data() {
    return {
      organizations: [],
      search: "",
      headers: [
        { text: "Name",  value: "name", sortable: true },
        { text: "Status", value: "status", sortable: true },
        { text: "Email", value: "email", sortable: true },
        { text: "Actions", value: "actions", sortable: false }
      ]
    };
  },

  methods: {
    fetchOrganizations() {
      this.$setLoader();
        
      service.fetchOrganizations().then(r => {
        this.organizations = r.data.organizations;
        this.$disableLoader();
      });
    },

    createOrganization() {
      this.$router.push({ name: "OrganizationCreate" });
    }
  },

  mounted() {
    this.fetchOrganizations();
  }
};
</script>

<style scoped>
#bt1 {
  float: right;
}
</style>
